"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var PORTAL_HEALTH_STATES = (0, _keyMirror.default)({
  DEFAULT: null,
  PROBATION_1: null,
  PROBATION_2: null,
  PROBATION_3: null,
  SUSPENDED: null
});
var _default = PORTAL_HEALTH_STATES;
exports.default = _default;
module.exports = exports.default;